import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { resetPassword } from './actions';
import { selectError, selectMessage, selectSending } from './selectors';
import { Button, Muted } from '../Controls';
import { Page, PageTitle, Panel } from '../Page';
import { ErrorText, Field, Input } from '../Login/styled';

/** Sets a new password, from the link in the reset email (its token and address are in the address bar). */
const ResetPassword = () => {
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const sending = useSelector(selectSending);
  const message = useSelector(selectMessage);
  const error = useSelector(selectError);
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const token = params.get('token');
  const email = params.get('email');

  if (!token || !email) {
    return (
      <Page>
        <PageTitle>Set a new password</PageTitle>
        <Panel>
          <p>This link is missing part of itself. <Link to="/forgot-password">Ask for a new one</Link>.</p>
        </Panel>
      </Page>
    );
  }

  return (
    <Page>
      <PageTitle>Set a new password</PageTitle>
      <Panel>
        {message ? <p role="status">{message} <Link to="/login">Log in</Link></p> : (
          <form onSubmit={(event) => { event.preventDefault(); dispatch(resetPassword(token, email, password, confirmation)); }}>
            <p><Muted>For {email}</Muted></p>
            <Field>
              <label htmlFor="password">New password</label>
              <Input type="password" id="password" autoComplete="new-password" minLength={8} required value={password} onChange={(event) => setPassword(event.target.value)} />
            </Field>
            <Field>
              <label htmlFor="confirmation">The same again</label>
              <Input type="password" id="confirmation" autoComplete="new-password" minLength={8} required value={confirmation} onChange={(event) => setConfirmation(event.target.value)} />
            </Field>
            {error && <ErrorText role="alert">{error}{/expired|used/.test(error) && <> <Link to="/forgot-password">Get a new link</Link></>}</ErrorText>}
            <Button $primary $block disabled={sending}>{sending ? 'Saving…' : 'Set the password'}</Button>
          </form>
        )}
      </Panel>
    </Page>
  );
};

export default ResetPassword;
